export default __webpack_public_path__ + "static/media/activeSub.9d8d7d25.svg";